import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import image1 from "../../assets/images/image1.svg";
import image3 from "../../assets/images/image3.svg";
import image4 from "../../assets/images/image4.svg";
import CutImage2 from "../../assets/images/CutImage2.png";
import "../../assets/styles/local/PageNotFound.css";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //   logErrorToMyService(error, errorInfo);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="mainDiv">
          <div className="image1">
            <img src={image1} alt="" className="image1size" />
          </div>

          <div className="ASC">
            <div className="OopDiv" style={{ marginTop: "80px" }}>
              <div className="d-flex oopsSection">
                <img src={image3} alt="" className="image3size" />
                <p>
                  <span className="circleText">O</span>
                  <span className="circleText">O</span>
                  <span className="psText">ps...</span>
                </p>
              </div>

              <div className="image4">
                <img src={image4} alt="" className="image4size" />
              </div>

              <div className="d-flex pt-2 pageNotFoundSection">
                <p>Page not found</p>
              </div>

              <br></br>
              <div className="textSection pt-2">
                <p>It seems we are not able to find the</p>
              </div>

              <div className="text2Section pt-2">
                <p>page you are looking for.</p>
              </div>

              <div className="text3Section pt-2">
                <p> Please try again later or change</p>
              </div>

              <div className="text4Section pt-2">
                <p>the search criteria.</p>
              </div>
            </div>
          </div>

          <div className="www">
            <div className="halfimgDiv">
              <img src={CutImage2} alt="" className="CutImage" />
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
